import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { dashboardSchema } from '_services/_schemas';
import { getDateMDYY } from '_helpers';

export const dashboardService = {
    loadSchedule,
    loadOutstandingNotes,
    saveUserPreferences,
    getUserPreferences
};

async function loadSchedule(date) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/dashboard/getschedule?date='+getDateMDYY(date), requestOptions, true)
    .then(data => {
        var flat = normalize(data, dashboardSchema);
        return flat;
    });

}


async function loadOutstandingNotes() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/dashboard/getoutstandingnotes', requestOptions, true)
    .then(data => {
        var flat = normalize(data, dashboardSchema);
        return flat;
    });

}

async function saveUserPreferences(evalStatus) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ evalStatus })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/dashboard/saveuserpreferences', requestOptions, true);
}

async function getUserPreferences() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/dashboard/getuserpreferences', requestOptions, true)
    .then(data => {
        return data;
    });

}